'use strict';

import angular from 'angular';

export function Modal($rootScope, $uibModal, gettextCatalog) {
  'ngInject';
  /**
   * Opens a modal
   * @param  {Object} scope      - an object to be merged with modal's scope
   * @param  {String} modalClass - (optional) class(es) to be applied to the modal
   * @return {Object}            - the instance $uibModal.open() returns
   */
  function openModal(scope = {}, modalClass = 'modal-default') {
    var modalScope = $rootScope.$new();

    angular.extend(modalScope, scope);

    return $uibModal.open({
      template: require('./modal.html'),
      windowClass: modalClass,
      scope: modalScope
    });
  }

  // Public API here
  return {

    /* Confirmation modals */
    confirm: {

      /**
       * Create a function to open a delete confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
       * @param  {Function} del - callback, ran when delete is confirmed
       * @return {Function}     - the function to open the modal (ex. myModalFn)
       */
      delete(del = angular.noop) {
        /**
         * Open a delete confirmation modal
         * @param  {String} name   - name or info to show on modal
         * @param  {All}           - any additional args are passed straight to del callback
         */
        return function(...args) {
          var slicedArgs = JSON.parse(JSON.stringify(args));
          //var slicedArgs = Reflect.apply(Array.prototype.slice, arguments);
          //var slicedArgs = Array.prototype.slice.call(arguments);
          //var name = slicedArgs.shift();
          let title = slicedArgs[0];
          let text = slicedArgs[1];
          let confirmText = slicedArgs[2];
          let cancelText = slicedArgs[3];

          var deleteModal;

          deleteModal = openModal({
            modal: {
              dismissable: true,
              title,
              text,
              buttons: [{
                classes: 'btn-default',
                text: cancelText,
                click(e) {
                  deleteModal.dismiss(e);
                }
              }, {
                classes: 'btn-danger',
                text: confirmText,
                click(e) {
                  deleteModal.close(e);
                }
              }]
            }
          }, 'modal-danger');

          deleteModal.result.then(function(event) {
            Reflect.apply(del, event, slicedArgs);
          }).catch(function() {
            return null;
          });
        };
      },


      /**
       * Create a function to open a validate confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
       * @param  {Function} val - callback, ran when delete is confirmed
       * @return {Function}     - the function to open the modal (ex. myModalFn)
       */
      info(val = angular.noop) {
        /**
         * Open a delete confirmation modal
         * @param  {All}           - any additional args are passed straight to del callback
         */
        return function() {
          var slicedArgs = JSON.parse(JSON.stringify(arguments));
          //var slicedArgs = Reflect.apply(Array.prototype.slice, arguments);
          //var slicedArgs = Array.prototype.slice.call(arguments);
          //var name = slicedArgs.shift();
          let title = slicedArgs[0];
          let text = slicedArgs[1];
          let confirmText = slicedArgs[2];
          let type = slicedArgs[3];

          var savedModal;

          savedModal = openModal({
            modal: {
              dismissable: true,
              title,
              text,
              buttons: [{
                classes: `btn-${type}` || 'default',
                text: confirmText,
                click(e) {
                  savedModal.close(e);
                }
              }]
            }
          }, `modal-${type}` || 'default');

          savedModal.result.then(function(event) {
            Reflect.apply(val, event, {});
          }).catch(function() {
            return null;
          });
        };
      },

      /**
       * Create a function to open a validate confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
       * @param  {Function} val - callback, ran when delete is confirmed
       * @return {Function}     - the function to open the modal (ex. myModalFn)
       */
      validate(val = angular.noop) {
        /**
         * Open a delete confirmation modal
         * @param  {All}           - any additional args are passed straight to del callback
         */
        return function() {
          var validateModal;

          validateModal = openModal({
            modal: {
              dismissable: true,
              title: gettextCatalog.getString('Envoyer la demande'),
              html: `<p>${gettextCatalog.getString('Voulez-vous envoyer cette demande?')}</p>`,
              buttons: [{
                classes: 'btn-success',
                text: gettextCatalog.getString('Envoyer'),
                click(e) {
                  validateModal.close(e);
                }
              }, {
                classes: 'btn-default',
                text: gettextCatalog.getString('Annuler'),
                click(e) {
                  validateModal.dismiss(e);
                }
              }]
            }
          }, 'modal-success');

          validateModal.result.then(function(event) {
            Reflect.apply(val, event, {});
          }).catch(function() {
            return null;
          });
        };
      }


    }
  };
}

export default angular.module('dalApp.Modal', [])
  .factory('Modal', Modal)
  .name;



// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js